"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("Core/Body");
exports.Step3Component = function () {
  var Selector = {
    FORM: "#step3_form",
    FINAL_BUTTON_CART: "#lastStepCartButtonFinal",
    LIGHT_PRELOADER: "#light-preloader"
  };
  function preventClickButton(e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    $(Selector.LIGHT_PRELOADER).removeClass("d-none");
    $(Selector.FORM).submit();
  }
  function showButton() {
    setTimeout(function () {
      $(Selector.FINAL_BUTTON_CART).removeClass("d-none");
    }, 500);
  }
  $(window).on("load", showButton);
  Body_1.$body.on("click", Selector.FINAL_BUTTON_CART, preventClickButton);
}();